import { render, staticRenderFns } from "./soaking.vue?vue&type=template&id=61605cee&scoped=true"
import script from "./soaking.vue?vue&type=script&lang=js"
export * from "./soaking.vue?vue&type=script&lang=js"
import style0 from "./soaking.vue?vue&type=style&index=0&id=61605cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61605cee",
  null
  
)

export default component.exports